import React from "react";

import { StyledNumber } from "./number.style";

const Number = ({
  register,
  value,
  name,
  required,
  placeholder,
  minValue,
  maxValue,
  stepValue,
  readOnly,
  error,
}) => (
  <StyledNumber error={error ? 1 : 0}>
    <input
      type="number"
      {...register(name, {
        required: {
          value: required,
          message: "This field is required",
        },
        value: value,
        valueAsNumber: true,
        min: {
          value: minValue,
          message: `Minimum value is ${minValue}`,
        },
        max: {
          value: maxValue,
          message: `Maximum value is ${maxValue}`,
        },
      })}
      placeholder={placeholder}
      step={stepValue}
      min={minValue}
      max={maxValue}
      readOnly={readOnly}
      onWheel={(e) => e.target.blur()}
    />
    <span className="error">{error?.message || ""}</span>
  </StyledNumber>
);

export default Number;
